import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useAgendamentoEntrega, { LOAD_MESSAGE } from './AgendamentoEntregaHook'
import { CustomDataTableHeader, CustomPanel, PageHeader } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { withRouter } from 'react-router'
import { formatIsoDateToLocale } from '../../../../../services/util/date.service'
import ModalAgendamento from './ModalAgendamento/ModalAgendamento'

function AgendamentoEntrega({ dispatch, history }) {
  const cargaParada = history.location.state.cargaParada
  const { state, localDispatch } = useAgendamentoEntrega()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getAgendamentosEntrega(cargaParada.delivery_id)
        break

      case LOAD_MESSAGE.SAVE_REASON:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>Agendamentos de Entregas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          showBtnNovo={true}
          onVoltar={history.goBack}
          onNovo={() => localDispatch.onBtnNovoClicked(cargaParada.delivery_id)}
        >
          <div>
            <div style={{ marginTop: 20 }}>
              <DataTable
                value={state.agendamentos}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                globalFilter={state.globalFilter}
                emptyMessage="Não existem veiculos para atribuir as informações "
                paginator={true}
                rows={10}
                style={{ textAlign: 'center' }}
              >
                <Column field="id" header="Código" style={tableCellCentered(150)} />
                <Column
                  field="date"
                  header="Data Agendamento"
                  body={i => formatIsoDateToLocale(i.date).toFormat('dd/MM/yyyy HH:mm')}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalAgendamento
        show={state.modalAgendamentos.show}
        data={state.modalAgendamentos.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(AgendamentoEntrega))
